var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"iconfont iconios-qr-scanner",staticStyle:{"font-size":"20px"},on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }